export default "__VITE_ASSET__mmgICWST__"